import script from "./WebSocketBarcode.vue?vue&type=script&lang=js"
export * from "./WebSocketBarcode.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__